import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import ContactSecTwo from '../components/sections/ContactSecTwo';
import ContactSecThree from '../components/sections/ContactSecThree';

const Contact = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.contact.title" subtitleKey="sections.breadcrumb.contact.subtitle" />
        <ContactSecTwo className="space overflow-hidden" />
        <ContactSecThree className="space-bottom overflow-hidden" />
      <Footer />
    </>
  );
};

export default Contact;